import { CreateNS } from '../lib/createAPIBuilder';

export const installAPILifecycle = (namespace: CreateNS) => {
    namespace('lifecycle')(({ func, deps }) => {
        func('onChapterLoad', deps.lifecycle.onChapterLoad);
        func('onChapterUnload', deps.lifecycle.onChapterUnload);
        func('onChapterWillLoad', deps.lifecycle.onChapterWillLoad);
        func('onChapterWillUnload', deps.lifecycle.onChapterWillUnload);
        func('onChapterDidLoad', deps.lifecycle.onChapterDidLoad);
        func('onChapterDidUnload', deps.lifecycle.onChapterDidUnload);
    });
};
